exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".restaurants-venuescardsslider-component{padding-top:48px}@media (max-width:768px){.restaurants-venuescardsslider-component>*{padding-right:0!important;padding-left:0!important}}.restaurants-venuescardsslider-component .well{height:420px}@media (max-width:768px){.restaurants-venuescardsslider-component .well{padding-right:0!important;padding-left:0!important}}.restaurants-venuescardsslider-component__title{padding-bottom:48px}.restaurants-venuescardsslider-component__slider{margin-top:-48px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/restaurants/venuescardsslider.scss
// module id = 1030
// module chunks = 0